<template>
  <h2 class="sky-span">{{ data }}</h2>
</template>

<script>
export default {
  name: 'sky-line',
  props: {
    data: {
      required: true,
    },
  },
}
</script>

<style scoped>
.sky-span {
  color: #000;
  line-height: 1.7em;
  border-bottom: 4px solid #3da1ff;
}
</style>
